import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

interface PayoutStatusIndicatorProps {
  hasPayoutAccount: boolean;
  payoutStatus?: 'ENABLED' | 'DISABLED';
  compact?: boolean;
}

/**
 * Indicator showing if a partner is ready to receive payouts
 */
const PayoutStatusIndicator: React.FC<PayoutStatusIndicatorProps> = ({
  hasPayoutAccount,
  payoutStatus,
  compact = false,
}) => {
  const isReady = hasPayoutAccount && payoutStatus === 'ENABLED';

  if (compact) {
    return (
      <View style={styles.compactContainer}>
        <Ionicons
          name={isReady ? 'checkmark-circle' : 'alert-circle'}
          size={14}
          color={isReady ? '#10B981' : '#F59E0B'}
        />
      </View>
    );
  }

  return (
    <View style={[styles.container, isReady ? styles.ready : styles.notReady]}>
      <Ionicons
        name={isReady ? 'checkmark-circle' : 'alert-circle'}
        size={14}
        color={isReady ? '#10B981' : '#F59E0B'}
      />
      <Text style={[styles.text, isReady ? styles.textReady : styles.textNotReady]}>
        {isReady ? 'Ready to receive' : 'Needs to set up payouts'}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    gap: 4,
  },
  ready: {
    backgroundColor: 'rgba(16, 185, 129, 0.1)',
  },
  notReady: {
    backgroundColor: 'rgba(245, 158, 11, 0.1)',
  },
  compactContainer: {
    padding: 2,
  },
  text: {
    fontSize: 12,
    fontWeight: '600',
  },
  textReady: {
    color: '#10B981',
  },
  textNotReady: {
    color: '#F59E0B',
  },
});

export default PayoutStatusIndicator;

